module.exports = __webpack_public_path__ + "sms_38x38.4661fd6ccaded3a68b1803ac32b26592.png";